module.exports = __webpack_public_path__ + "img/grupowe_kwadrat.f34b2d52.webp";